import React from 'react';
import {Modal} from 'antd';
import {EmailPreviewT} from '../../types/codes';
import {EmailPreview} from '../../components/CodeGroup/View/EmailPreview';
import {EmailPreviewHeader} from '../../components/CodeGroup/View/EmailPreviewHeader';
import {useEmailPreviewActions} from '../../hooks/emailPreview';
import {getEmailPreview} from '../../queries/codes';

export const useEmailPreview = (groupId?: number | string) => {
  const loadEmailPreview = async (guestId?: string) => {
    if (!guestId || !groupId) return;
    try {
      const res = await getEmailPreview({groupId: String(groupId), guestId: guestId});
      const preview = res?.body as EmailPreviewT;

      console.log('res', preview);

      // Create a component that uses the hook
      const HeaderWithActions = () => {
        const {handleCopyEmail, handleSavePDF} = useEmailPreviewActions(preview);
        return <EmailPreviewHeader onCopyEmail={handleCopyEmail} onSavePDF={handleSavePDF} />;
      };

      Modal.info({
        title: <HeaderWithActions />,
        content: (
          <EmailPreview emailBody={preview.emailBody} subject={preview.subject} from={preview.from} to={preview.to} />
        ),
        okButtonProps: {
          style: {
            display: 'none',
          },
        },
        closable: true,
        className: 'preview',
      });
    } catch (error) {}
  };

  return {loadEmailPreview};
};
